import { useState, useCallback } from "react";
import MUIConfirmDialog from "@/components/modals/MUIConfirmDialog";

type DialogButtonConfig = Record<string, unknown>;

interface AlertConfig {
  show: boolean;
  title: string;
  description: string;
  dialogButtonConfig: DialogButtonConfig;
}

const emptyAlertConfig: AlertConfig = {
  show: false,
  title: "",
  description: "",
  dialogButtonConfig: {},
};

const useConfirmDialog = () => {
  const [alertConfig, setAlertConfig] = useState({
    ...emptyAlertConfig,
  });

  const showConfirmDialog = useCallback(
    (
      title: string,
      description: string,
      dialogButtonConfig: DialogButtonConfig = {}
    ) => {
      setAlertConfig({
        show: true,
        title,
        description,
        dialogButtonConfig,
      });
    },
    []
  );

  const closeConfirmDialog = useCallback(() => {
    setAlertConfig({
      ...emptyAlertConfig,
    });
  }, []);

  // Render the dialog when alertConfig.show is true
  const MUIConfirmDialogBox = useCallback(() => {
    return alertConfig.show ? (
      <MUIConfirmDialog
        show={alertConfig.show}
        onClose={closeConfirmDialog}
        title={alertConfig.title}
        description={alertConfig.description}
        dialogButtonConfig={alertConfig.dialogButtonConfig}
      />
    ) : null;
  }, [alertConfig, closeConfirmDialog]);

  return {
    showConfirmDialog,
    closeConfirmDialog: closeConfirmDialog,
    MUIConfirmDialogBox: MUIConfirmDialogBox, // Provide the AlertDialog component to be used in the component tree
  };
};

export default useConfirmDialog;
